
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";

@Component({
  components: { IconButton }
})
export default class Dialog extends Vue {
  @Prop()
  type: "success" | "warning" | "error" | "info" | undefined;

  @Prop()
  value!: boolean;

  @Prop({ default: false })
  closeable!: boolean;

  @Prop({ default: false })
  sticky!: boolean;

  @Prop({ default: false })
  resizable!: boolean;

  @Prop({ default: false })
  border!: boolean;

  @Prop({ default: 400 })
  width!: number;

  get totalWidth() {
    if (this.resizable) {
      return Math.max(
        this.width,
        this.width + this.lastResizingX - this.startResizingX
      );
    }

    return this.width;
  }

  close() {
    this.$emit("input", false);
    this.$emit("close");
  }

  // Resizing logic
  resizing = false;
  startResizingX = 0;
  lastResizingX = 0;

  dragStart(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    this.startResizingX = event.clientX;
    this.resizing = true;

    document.addEventListener("mousemove", this.onDrag);
    document.addEventListener("mouseup", this.dragEnd);
  }

  onDrag(event: MouseEvent) {
    event.preventDefault();
    this.lastResizingX = event.clientX;
  }

  dragEnd(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;

    document.removeEventListener("mousemove", this.onDrag);
    document.removeEventListener("mouseup", this.dragEnd);
  }
}
